const TipoZona = {
    PlanInternet: "planInt",
    ServiciosGen: "servGen",
    Articulo: "art",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
};

export {TipoZona, Udm, Moneda };
